import * as Sentry from '@sentry/react';
import get from 'lodash/get';
import { useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import {
  Route,
  Routes as ReactRoutes,
  useLocation,
  useNavigationType,
  createRoutesFromChildren,
  matchRoutes,
} from 'react-router';

import PackWrapper from 'components/common/PackWrapper';
import NutritionalFactsContainer from 'components/nutritionFacts/NutritionalFactsContainer';
import { getStore } from 'store/configure';

const store = getStore();

const SentryRoutes = Sentry.withSentryReactRouterV6Routing(ReactRoutes);

Sentry.addIntegration(
  Sentry.reactRouterV6BrowserTracingIntegration({
    useEffect,
    useLocation,
    useNavigationType,
    createRoutesFromChildren,
    matchRoutes,
  })
);

document.addEventListener('DOMContentLoaded', () => {
  const rootElement = document.querySelector('#nutrition-facts-panel');
  const mealHashId = get(rootElement, 'dataset.mealHashId');
  const root = createRoot(rootElement);

  root.render(
    <PackWrapper rootElement={rootElement} store={store}>
      {mealHashId ? (
        <NutritionalFactsContainer domMealId={mealHashId} />
      ) : (
        <SentryRoutes>
          <Route path="/qr/:mealId/:packingFacility" element={<NutritionalFactsContainer />} />
        </SentryRoutes>
      )}
    </PackWrapper>
  );
});
